import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onErrorHandler } from './handlers';
import { config } from '../utils/config';
import { errorOperationNames } from '../enums/pccEnums';

declare const window: any;

export const customizeApi = createApi({
    reducerPath: 'customizeApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['customize'],
    endpoints: (builder) => ({
        getImprintInfo: builder.query({
            query: ({ regionCode, lang, mcpSku, variantId, productKey }) => ({
                url: `${window.Config?.LAMBDA_CUSTOMIZE}v1/imprintInfo/${mcpSku}` ?? `https://npr-customize.api.pens.com/v1/imprintInfo/${mcpSku}`,
                params: { regionCode: regionCode, lang: lang, variantId: variantId, productKey: productKey},
                method: 'GET'
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error) {
                    dispatch(onErrorHandler({operation: errorOperationNames.GET_IMPRINT_INFO, err: JSON.stringify(error), errMsg: 'Error: while fetching imprintInfo', api: `${window.Config?.LAMBDA_CUSTOMIZE}v1/imprintInfo`}));     
                }
            }
        }),
        getAccessToken: builder.query({
            query: () => ({
                url: config('accessTokenUrl'),
                params: { api_key: config('cimpressApiTokenUrl')},
                method: 'GET'
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error) {
                    dispatch(onErrorHandler({operation: errorOperationNames.GET_ACCESS_TOKEN, err: JSON.stringify(error), errMsg: 'Error: while fetching AccessToken', api: `https://api.cimpress.io/auth/anonymous/v1/tokens`}));     
                }
            }
        }),
        uploadLogo: builder.mutation({
            async queryFn({logoImage, accessToken}, {dispatch, getState}, _extraOptions,  baseQuery) {
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                };
                const encodedProcess = encodeURIComponent(JSON.stringify({
                    type: "image",
                    arguments: {
                        storeOriginal: "true",
                    }
                }));
                const response:any = await baseQuery({ url: `${config('artworkLogoUploadUrl')}?process=${encodedProcess}&tenant=${config('tenant')}`,
                    method: 'POST',
                    body: logoImage,
                    headers,
                });
                return response;
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error) {
                    dispatch(onErrorHandler({operation: errorOperationNames.UPLOAD_LOGO, err: JSON.stringify(error), errMsg: 'Error: while uploading Logo', api: `https://uploads.documents.cimpress.io/v1/uploads`}));     
                }
            }
        }),
        generateDocRefUrl: builder.mutation({
            async queryFn({mcpSku, accessToken, customizationInfo}, {dispatch, getState}, _extraOptions,  baseQuery) {
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                };
                const response:any = await baseQuery({ url: `${config('artworkDocRefUrl')}${mcpSku}/autoplacecomponent`,
                    method: 'POST',
                    body: customizationInfo,
                    headers,
                });
                return response;
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error) {
                    dispatch(onErrorHandler({operation: errorOperationNames.GENERATE_DOC_REFRENCE_URL, err: JSON.stringify(error), errMsg: 'Error: while generating doc ref Url', api: `https://dim.api.pens.com/v1/products/sku/mcpSku/autoplacecomponent`}));     
                }
            }
        }),
    }),
})

export const {
    useGetImprintInfoQuery,
    useGetAccessTokenQuery,
    useUploadLogoMutation,
    useGenerateDocRefUrlMutation,
} = customizeApi;